const SET_PAYOUT_DETAILS = (state, data) => {
  state.payoutDetails = data;
};

const SET_AVAILABLE_PAYOUT_AMOUNTS = (state, data) => {
  state.availablePayoutAmounts = data;
};

export default {
  SET_PAYOUT_DETAILS,
  SET_AVAILABLE_PAYOUT_AMOUNTS,
};
